import { facebookIcon } from './facebookIcon';
import { mailIcon } from './mailIcon';
import { pinterestIcon } from './pinterestIcon';
import { redditIcon } from './redditIcon';
import { tumblrIcon } from './tumblrIcon';
import { vkIcon } from './vkIcon';
import { weiboIcon } from './weiboIcon';
import { whatsappIcon } from './whatsappIcon';
import { xIcon } from './xIcon';

export {
  facebookIcon,
  mailIcon,
  pinterestIcon,
  redditIcon,
  tumblrIcon,
  vkIcon,
  weiboIcon,
  whatsappIcon,
  xIcon,
};
